module.exports = __webpack_public_path__ + "static/media/aboutPagesContent.ed596925.yaml";